module.exports = __webpack_public_path__ + "media/images/country_flags/na-80961918fece9286ed18e40591b9e796.png";